import { toast } from 'react-toastify'


function ToasterWithMessage() {
  const error = (message: string, delay = 2000) => {
    toast.error(message, { autoClose: delay });
    return true;
  };

  const success = (message: string, delay = 2000) => {
    toast.success(message, { autoClose: delay });
    return true;
  };

  const info =(message: string, delay = 2000) => {
    toast.info(message, { autoClose: delay });
    return true;
  }
  return { error, success, info };
}


export default ToasterWithMessage;
